(function () {

    angular
        .module('app')
        .controller('TeacherRestrictionsController', TeacherRestrictionsController);

    TeacherRestrictionsController.$inject = [
        'authService',
        'usersService',
        '$mdDialog'
    ];

    function TeacherRestrictionsController(authService, usersService, $mdDialog) {

        var vm = this;
        vm.authService = authService;

        vm.saving = false;

        var alertId = 1;
        vm.errors = [];
        vm.warnings = [];
        vm.dismissAlert = function (type, errIdx) {
            vm[type].splice(errIdx, 1);
        };
        function displayAlert(type, status, errObj) {
            if (!errObj) {
                errObj = {};
            }
            var newId = alertId++;
            vm[type].push({
                alertid : newId,
                message : errObj.message || errObj.error || '未知错误',
                status : status
            });
            return newId;
        }

        vm.hasProjectType = function (projectType) {
            if (!vm.policy || !vm.policy.supportedProjectTypes) {
                return false;
            }
            if (projectType === 'imgtfjs' || projectType === 'images') {
                return vm.policy.supportedProjectTypes.indexOf('imgtfjs') >= 0 ||
                       vm.policy.supportedProjectTypes.indexOf('images') >= 0;
            }
            return vm.policy.supportedProjectTypes.indexOf(projectType) >= 0;
        };

        vm.getSupportedProjectTypes = function () {
            if (!vm.policy || !vm.policy.supportedProjectTypes) {
                return [];
            }
            return vm.policy.supportedProjectTypes;
        };

        vm.getProjectTypeLabel = function (projectType) {
            if (projectType === 'text') {
                return '文字识别';
            }
            if (projectType === 'numbers') {
                return '数字分类';
            }
            if (projectType === 'imgtfjs' || projectType === 'images') {
                return '图像识别';
            }
            if (projectType === 'sounds') {
                return '声音识别';
            }
            if (projectType === 'regression') {
                return '数值预测';
            }
            if (projectType === 'language') {
                return '文字生成';
            }
            return projectType;
        };

        vm.hoursFilter = function (hours) {
            if (hours === 1) {
                return '1 小时';
            }
            else if (hours < 24) {
                return hours + ' 小时';
            }
            else if (hours === 24) {
                return '1 天';
            }
            else if (hours < 168) {
                return Math.floor(hours / 24) + ' 天 ' + (hours % 24) + ' 小时';
            }
            else if (hours === 168) {
                return '1 周';
            }
            else {
                return '1 周 ' +
                       Math.floor((hours - 168) / 24) + ' 天 ' + (hours % 24) + ' 小时';
            }
        };


        authService.getProfileDeferred()
            .then(function (profile) {
                vm.profile = profile;

                if (profile.role === 'supervisor') {

                    usersService.getClassPolicy(profile)
                        .then(function (policy) {
                            vm.policy = policy;
                        })
                        .catch(function (err) {
                            displayAlert('errors', err.status, err.data);
                        });
                }
            })
            .catch(function (err) {
                displayAlert('errors', err.status, err.data);
            });

        vm.modifyExpiry = function (ev) {
            var initialtextexpiry = vm.policy.textClassifierExpiry;

            $mdDialog.show({
                controller : ["$scope", "$mdDialog", function ($scope, $mdDialog) {
                    $scope.initialtextexpiry = initialtextexpiry;

                    $scope.textexpiry = vm.policy.textClassifierExpiry;

                    $scope.hoursfilter = function (hours) {
                        return vm.hoursFilter(hours);
                    };

                    $scope.hide = function () {
                        $mdDialog.hide();
                    };
                    $scope.cancel = function () {
                        $mdDialog.cancel();
                    };
                    $scope.confirm = function (resp) {
                        $mdDialog.hide(resp);
                    };
                }],
                templateUrl : 'static/components/teacher_restrictions/modifyexpiry.tmpl.html?v=20260531-project-rules',
                targetEvent : ev,
                clickOutsideToClose : true
            })
            .then(
                function (expiries) {
                    vm.saving = true;
                    vm.policy.textClassifierExpiry = '...';

                    usersService.modifyClassPolicy(vm.profile, expiries.textexpiry)
                        .then(function (tenantinfo) {
                            vm.saving = false;
                            vm.policy.textClassifierExpiry = tenantinfo.textClassifierExpiry;
                        })
                        .catch(function (err) {
                            vm.saving = false;
                            displayAlert('errors', err.status, err.data);
                            vm.policy.textClassifierExpiry = initialtextexpiry;
                        });
                },
                function() {
                    // cancelled. do nothing
                }
            )
        };
    }
}());
